import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	Alert,
} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { DatePickerInput, DatesProvider } from '@mantine/dates';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

//redux
import { setRequireCloseModal } from '../../../../slices/powerGenerationHourMeter/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
	addNewPowerGenerationHourMeter,
	updatePowerGenerationHourMeter,
} from '../../../../slices/powerGenerationHourMeter/thunk';
import OSelect from '../../../../Components/OElements/OSelect';
import {
	getConsumptionSourceList,
	getConsumptionSourceTypeList,
	getConsumptionTypeList,
	getFeedingBargesList,
	getFuelSupplyList,
	getFuelTankList,
	getFuelTankListByEstablishment,
	getPowerGenerationSourceList,
} from '../../../../helpers/establishment/backend_helper';
import {
	addNewFuelSupply,
	getEstablishment,
	getFuelTank,
	getProductiveCycleActive,
	uploadFile,
} from '../../../../slices/thunks';

import { getFuelSupplyTypeCode } from '../../../../slices/fuelSupplyType/thunk';
import OInput from '../../../../Components/OElements/OInput';
import OHr from '../../../../Components/OElements/OHr';
import { getFileType } from '../../../../helpers/file_manager/backend_helper';
import { useUser } from '../../../../Components/Hooks/useUserHooks';

const PowerGenerationConsumptionForm = ({
	establishment_id,
	dataPowerGenerationHourMeter,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();
	const { user } = useUser();

	const [establishment, setEstablishment] = useState('-');
	const [feedingBarges, setFeedingBarges] = useState('-');
	const [type, setType] = useState('-');
	const [power_generation_status, setStatus] = useState('-');
	const [hour_meter_last, setHourMeterLast] = useState('-');
	const [date_hour_meter_last, setDateHourMeterLast] = useState(null);
	const [powerGenerationSource, setPowerGenerationSource] = useState(null);

	const [unit_measurement_name, setUnitMeasurementName] = useState('-');
	const [fuel_tank_name, setFuelTankName] = useState('-');
	const [fuel_type_name, setFuelTypeName] = useState('-');
	const [stock, setStock] = useState('-');
	const [errorFuelTank, setErrorFuelTank] = useState(false);

	const [itemFuelTankDetail, setItemFuelTankDetail] = useState(null);

	const [cs, setCS] = useState(false);
	const [pgs, setPGS] = useState(false);

	const [consumptionType, setConsumptionType] = useState(null);
	const [consumptionSource, setConsumptionSource] = useState(null);

	const [fuelTank, setFuelTank] = useState('-');

	const [fileCol, setFileCol] = useState(true);
	const [code_type_document, setCodeTypeDocument] = useState('AUT');
	const [fileName, setFileName] = useState('');

	const selectorPowerGenerationHourMeter = createSelector(
		state => state.PowerGenerationHourMeter,
		result => ({
			isAdding: result.isAdding,
			isAdded: result.isAdded,
			isUpdating: result.isUpdating,
			isUpdated: result.isUpdated,
			isLoadingList: result.isLoadingList,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorPowerGenerationHourMeter);

	const selectorEstablishments = createSelector(
		state => state.Establishments,
		establishment => ({
			productive_cycle: establishment.productiveCycleActiveDetail,
			establishment_info: establishment.itemEstablishmentDetail,
			isLoading: establishment.isLoading,
			isSuccess: establishment.isSuccess,
			isError: establishment.isError,
		})
	);
	const {
		productive_cycle,
		establishment_info,
		isLoading,
		isSuccess,
		isError,
	} = useSelector(selectorEstablishments);

	const selectorPowerGenerationSource = createSelector(
		state => state.PowerGenerationSource,
		powerGenerationSource => ({
			itemPowerGenerationSourceList:
				powerGenerationSource.itemPowerGenerationSourceList,
			itemPowerGenerationSourceDetail:
				powerGenerationSource.itemPowerGenerationSourceDetail,
		})
	);
	const { itemPowerGenerationSourceList, itemPowerGenerationSourceDetail } =
		useSelector(selectorPowerGenerationSource);

	const selectorFuelSupplyTypeCode = createSelector(
		state => state.FuelSupplyType,
		data => ({
			itemFuelSupplyTypeDetail: data.itemFuelSupplyTypeDetail,
		})
	);
	const { itemFuelSupplyTypeDetail } = useSelector(selectorFuelSupplyTypeCode);

	const selectorFuelTank = createSelector(
		state => state.FuelTank,
		data => ({
			itemFuelTankDetailData: data.itemFuelTankDetail,
		})
	);
	const { itemFuelTankDetailData } = useSelector(selectorFuelTank);

	useEffect(() => {
		dispatch(getFuelSupplyTypeCode('consumption'));
		dispatch(getEstablishment(establishment_id));
	}, [establishment_id]);

	useEffect(() => {
		dispatch(getProductiveCycleActive(establishment_id));
	}, [establishment_id]);

	useEffect(() => {
		if (itemFuelTankDetailData) {
			setItemFuelTankDetail(itemFuelTankDetailData);
		} else {
			setItemFuelTankDetail(null);
		}
	}, [itemFuelTankDetailData]);

	const [typeDocument, setTypeDocument] = useState(null);
	const [name_type_document, setNameTypeDocument] = useState('Documento');

	const handleTypeDocumentSelect = optionSelected => {
		if (optionSelected && optionSelected.name) {
			setTypeDocument(optionSelected);
			setNameTypeDocument(optionSelected.name);
		} else {
			setNameTypeDocument('Documento');
		}
	};

	const handleFileChange = event => {
		const file = event.currentTarget.files[0];
		validation.setFieldValue('document', file);
		if (file) {
			setFileName(file.name); // Guarda el nombre del archivo
		} else {
			setFileName(''); // Restablece el nombre si no hay archivo
		}
	};

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			power_generation_source_id:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.power_generation_source_id) ||
				'',
			observation:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.observation) ||
				'',
			register_date:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.register_date) ||
				'',
			consumption_type_id:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.consumption_type_id) ||
				null,
			consumption: '', // Nuevo campo agregado
			feeding_barges_id: null,

			consumption_source_type_id: null,
			consumption_source_id: null,

			document:
				(dataPowerGenerationHourMeter &&
					dataPowerGenerationHourMeter.document) ||
				'',
			file_type_id: null,
		},
		validationSchema: Yup.object({
			observation: Yup.string().nullable(),
			feeding_barges_id: Yup.string().nullable(),

			register_date: Yup.string().required('Campo requerido'),
			consumption: Yup.number()
				.required('Campo requerido')
				.min(0, 'El consumo no puede ser menor que 0')
				.test(
					'max-stock',
					'El consumo no puede ser mayor que el saldo disponible',
					function (value) {
						return value <= stock;
					}
				)
				.test(
					'fuel-tank-required',
					'Debe seleccionar un estanque de combustible',
					function () {
						return (
							fuel_tank_name !== '-' || validation.values.fuel_tank_id
						);
					}
				),

			power_generation_source_id: Yup.lazy(() =>
				consumptionType?.code === 'PGS'
					? Yup.string().required('Campo requerido')
					: Yup.string().nullable()
			),

			consumption_type_id: Yup.string().required('Campo requerido'),
			consumption_source_type_id: Yup.lazy(() =>
				consumptionType?.code === 'CS'
					? Yup.string().required('Campo requerido')
					: Yup.string().nullable()
			),
			consumption_source_id: Yup.lazy(() =>
				consumptionType?.code === 'CS'
					? Yup.string().required('Campo requerido')
					: Yup.string().nullable()
			),
			fuel_tank_id: Yup.lazy(() =>
				consumptionType?.code === 'CS'
					? Yup.string().required('Campo requerido')
					: Yup.string().nullable()
			),

			file_type_id: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!fileCol && !value) {
							return false;
						}
						return true;
					}
				),

			document: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!fileCol && !value) {
							return false;
						}
						return true;
					}
				),
		}),
		onSubmit: async values => {
			if (fuel_tank_name === '-') {
				toast.error(
					'Debe seleccionar un estanque de combustible antes de registrar el consumo.'
				);
				return;
			}

			const powerGenerationConsumption = {
				consumption_type_id: values.consumption_type_id,
				observation: values.observation,
				consumption: values.consumption,
				// balance: itemFuelTankDetail.stock - values.consumption,
				productive_cycle_id: productive_cycle._id,
				feeding_barges_id: itemFuelTankDetail.feeding_barges_id,
				establishment_id: establishment_id,
				unit_measurement_id: itemFuelTankDetail.unit_measurement_id,
				fuel_type_id: itemFuelTankDetail.fuel_type_id,
				fuel_tank_id: itemFuelTankDetail._id,
				register_date: values.register_date,
			};

			if (consumptionType?.code == 'CS') {
				powerGenerationConsumption['consumption_source_id'] =
					values.consumption_source_id;
				powerGenerationConsumption['consumption_source_type_id'] =
					values.consumption_source_type_id;

				if (
					consumptionSource &&
					consumptionSource.emission_calculation &&
					consumptionSource.fuel_type &&
					consumptionSource.fuel_type.emission_factor
				) {
					powerGenerationConsumption['nominal_CO2'] =
						consumptionSource.fuel_type.emission_factor *
						values.consumption;
				}
			}

			if (consumptionType?.code == 'PGS') {
				powerGenerationConsumption['power_generation_source_id'] =
					values.power_generation_source_id;

				if (
					powerGenerationSource?.fuel_type &&
					powerGenerationSource.fuel_type.emission_factor
				) {
					powerGenerationConsumption['nominal_CO2'] =
						powerGenerationSource.fuel_type.emission_factor *
						values.consumption;
				}
			}

			if (isEdit) {
				powerGenerationConsumption._id = dataPowerGenerationHourMeter._id;
				const result = await dispatch(
					updatePowerGenerationHourMeter(powerGenerationConsumption)
				);
			} else {
				try {
					const result = await dispatch(
						addNewPowerGenerationHourMeter(powerGenerationConsumption)
					).unwrap();
					if (result) {
						let doc_id = null;
						const folderPath =
							'/' +
							establishment_info.establishment_type.name +
							'/' +
							establishment_info.code_siep +
							' - ' +
							establishment_info.name +
							'/Abastecimiento/Combustible';
						if (values.document) {
							const formData = new FormData();
							formData.append('file', values.document);
							try {
								const responseUploadFile = await dispatch(
									uploadFile({
										file_path: folderPath,
										file_type_id: typeDocument._id,
										formData: formData,
									})
								).unwrap();
								doc_id = responseUploadFile._id;
							} catch {
								console.error('Error al subir archivo');
							}
						}

						const fuelSupply = {
							amount: values.consumption,
							supply_date: values.register_date,
							fuel_tank_id: itemFuelTankDetail._id,
							fuel_type_id: itemFuelTankDetail.fuel_type._id,
							fuel_supply_type_id: itemFuelSupplyTypeDetail._id,
							observation: values.observation,
							productive_cycle_id: productive_cycle._id,
							establishment_id: establishment_id,
							feeding_barges_id: itemFuelTankDetail.feeding_barges_id,
							unit_measurement_id:
								itemFuelTankDetail.unit_measurement_id,
							power_generation_source_id:
								values.power_generation_source_id,
							power_generation_hour_meter_id: result._id,
						};

						if (!fileCol) {
							fuelSupply.file_id = doc_id;
							fuelSupply.file_type_id = values.file_type_id;
						}

						dispatch(addNewFuelSupply(fuelSupply));
					}
				} catch (err) {
					toast.error(err.message, { autoClose: 10000 });
				}
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	const handlePowerGenerationSourceSelect = optionSelected => {
		setPowerGenerationSource(optionSelected);
	};

	const handleConsumptionTypeSelect = optionSelected => {
		setConsumptionType(optionSelected);
		if (optionSelected) {
			if (optionSelected.code == 'CS') {
				setCS(false);
				setPGS(true);
			} else if (optionSelected.code == 'PGS') {
				setCS(true);
				setPGS(false);
			}
		} else {
			setCS(true);
			setPGS(true);
			setFeedingBarges('-');
			setType('-');
			setStatus('-');
			setHourMeterLast('-');
			setDateHourMeterLast('-');
			setItemFuelTankDetail(null);
		}
	};

	const handleConsumptionSourceSelect = optionSelected => {
		setConsumptionSource(optionSelected);

		if (optionSelected?.with_authorization) {
			setFileCol(false);
		} else {
			setFileCol(true);
		}
	};

	const handleFuelTankSelect = optionSelected => {
		if (optionSelected) {
			setItemFuelTankDetail(optionSelected);
			setUnitMeasurementName(optionSelected.unit_measurement?.name || '-');
			setFuelTypeName(optionSelected.fuel_type?.name || '-');
			setStock(optionSelected.stock || '-');
		} else {
			setItemFuelTankDetail(null);
			setUnitMeasurementName('-');
			setFuelTypeName('-');
			setStock('-');
		}
	};

	useEffect(() => {
		if (powerGenerationSource) {
			setEstablishment(powerGenerationSource.Establishment?.name);
			setFeedingBarges(powerGenerationSource.feeding_barges?.name);
			setType(powerGenerationSource.power_generation_type.name);

			setStatus(powerGenerationSource.power_generation_status.name);
			setHourMeterLast(powerGenerationSource.hour_meter);
			setDateHourMeterLast(
				powerGenerationSource.date_hour_meter
					? dayjs(powerGenerationSource.date_hour_meter).format(
							'DD-MM-YYYY HH:mm'
					  )
					: null
			);

			if (powerGenerationSource.fuel_tank_id) {
				dispatch(getFuelTank(powerGenerationSource.fuel_tank_id));
				setErrorFuelTank(false);
			} else {
				setErrorFuelTank(true);
				setItemFuelTankDetail(null);
			}
		} else {
			setFeedingBarges('-');
			setType('-');
			setStatus('-');
			setHourMeterLast('-');
			setDateHourMeterLast('-');
			setItemFuelTankDetail(null);
		}
	}, [powerGenerationSource]);

	useEffect(() => {
		if (itemFuelTankDetail) {
			setUnitMeasurementName(prev =>
				prev !== itemFuelTankDetail.unit_measurement?.name
					? itemFuelTankDetail.unit_measurement?.name || '-'
					: prev
			);
			setFuelTankName(prev =>
				prev !== itemFuelTankDetail.name
					? itemFuelTankDetail.name || '-'
					: prev
			);
			setFuelTypeName(prev =>
				prev !== itemFuelTankDetail.fuel_type?.name
					? itemFuelTankDetail.fuel_type?.name || '-'
					: prev
			);
			setStock(prev =>
				prev !== itemFuelTankDetail.stock
					? itemFuelTankDetail.stock ?? '-'
					: prev
			);
		} else {
			setUnitMeasurementName('-');
			setFuelTankName('-');
			setFuelTypeName('-');
			setStock('-');
		}
	}, [itemFuelTankDetail]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) {
					toast.error(
						'Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.',
						{ autoClose: 4000 }
					);
				}
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					{!Array.isArray(itemPowerGenerationSourceList) && (
						<Col lg={12}>
							<Alert color='info'>
								{itemPowerGenerationSourceDetail?.error}
							</Alert>
						</Col>
					)}

					{errorFuelTank && (
						<Col lg={12}>
							<div
								className='alert alert-danger alert-dismissible alert-label-icon rounded-label fade show'
								role='alert'
							>
								<i className={`${Icons.alert} label-icon`}></i>
								<strong>Verificación de Combustible</strong> La fuente
								de generación de energía no cuenta con un estanque de
								combustible asignado.
								<br />
								Por favor, verifique que el estanque cuente con
								suficiente combustible antes de completar esta acción.
							</div>
						</Col>
					)}

					<Col lg={3}>
						<OSelect
							key='consumption_type_id'
							label='Tipo Consumo'
							id='consumption_type_id'
							name='consumption_type_id'
							isRequired={true}
							value={validation.values.consumption_type_id || ''}
							onChange={validation.handleChange}
							onSelect={handleConsumptionTypeSelect}
							requestApi={() => getConsumptionTypeList({})}
							validation={validation}
						/>
					</Col>
				</Row>

				<Row className='g-3 mt-1' hidden={cs}>
					<Col lg={3}>
						<OSelect
							label='Tipo de Fuente de Consumo'
							id='consumption_source_type_id'
							name='consumption_source_type_id'
							isRequired={true}
							value={validation.values.consumption_source_type_id || ''}
							requestApi={() => getConsumptionSourceTypeList({})}
							validation={validation}
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							key={
								'consumption_source_id' +
								validation.values.consumption_source_type_id
							}
							label='Fuente de Consumo'
							id='consumption_source_id'
							name='consumption_source_id'
							isRequired={true}
							value={validation.values.consumption_source_id || ''}
							onSelect={handleConsumptionSourceSelect}
							requestApi={() =>
								getConsumptionSourceList({
									establishment_id: establishment_id,
									consumption_source_type_id:
										validation.values.consumption_source_type_id,
								})
							}
							validation={validation}
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							label='Estanque de Combustible'
							id='fuel_tank_id'
							name='fuel_tank_id'
							key={
								'fuel_tank_id' +
								establishment_id +
								validation.values.consumption_source_id
							}
							isRequired={true}
							value={validation.values.fuel_tank_id || ''}
							handleLabelOptions={item =>
								item.name +
								(item?.feeding_barges?.name
									? ' - ' + item?.feeding_barges?.name
									: '')
							}
							onSelect={handleFuelTankSelect}
							requestApi={() =>
								getFuelTankListByEstablishment({
									establishment_id: establishment_id,
									fuel_type_id: consumptionSource?.fuel_type_id,
								})
							}
							validation={validation}
						/>
					</Col>
				</Row>

				<Row className='g-3 mt-1' hidden={pgs}>
					{['SWE', 'LWE'].includes(
						establishment_info?.establishment_type?.code
					) && (
						<Col lg={3}>
							<OSelect
								label='Artefacto Naval'
								id='feeding_barges_id'
								name='feeding_barges_id'
								value={validation.values.feeding_barges_id || ''}
								// onSelect={handleFeedingBargesSelect}
								requestApi={() =>
									getFeedingBargesList({
										establishment_id: establishment_id,
									})
								}
								validation={validation}
							/>
						</Col>
					)}
					<Col lg={3}>
						<OSelect
							key={
								'power_generation_source_id' +
								establishment_id +
								validation.values.feeding_barges_id
							}
							label='Fuente de Generación de Energía'
							id='power_generation_source_id'
							name='power_generation_source_id'
							handleLabelOptions={item =>
								item.name +
								(item?.serial_number ? ' - ' + item?.serial_number : '')
							}
							isRequired={true}
							value={validation.values.power_generation_source_id || ''}
							onSelect={handlePowerGenerationSourceSelect}
							// requestApi={() => getPowerGenerationSourceList({ establishment_id: establishment_id })}
							requestApi={() => {
								return getPowerGenerationSourceList({
									establishment_id: establishment_id,
								}).then(options => {
									const filteredOptions = options.filter(
										option =>
											option.feeding_barges_id ==
											validation.values.feeding_barges_id
									);
									return filteredOptions;
								});
							}}
							validation={validation}
						/>
					</Col>

					<Col lg={3}>
						<OInput
							name='type'
							label='Tipo'
							type='text'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={type}
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='power_generation_status'
							label='Estado'
							type='text'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={power_generation_status}
						/>
					</Col>
				</Row>

				<Row className='g-3 mt-1'>
					<Col lg={2}>
						<OInput
							name='consumption'
							label='Consumo'
							type='number'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							disabled={cs && pgs}
						/>
					</Col>
					<Col sm={2}>
						<DatesProvider
							settings={{
								locale: 'es-mx',
								firstDayOfWeek: 1,
								weekendDays: [0],
								timezone: 'UTC',
							}}
						>
							<DatePickerInput
								label={
									<span>
										Fecha de Registro{' '}
										<span style={{ color: 'red' }}>*</span>
									</span>
								}
								id='register_date'
								name='register_date'
								placeholder='Seleccione una fecha'
								value={
									validation.values.register_date
										? new Date(validation.values.register_date)
										: null
								}
								onChange={date => {
									validation.setFieldValue('register_date', date);
								}}
								onBlur={validation.handleBlur}
								valueFormat='DD-MM-YYYY'
								maxDate={new Date()}
								{...(user?.role_code === 'CTO'
									? {
											minDate: new Date(
												new Date().getFullYear(),
												new Date().getMonth(),
												1
											),
									  }
									: {})}
								// minDate={new Date(new Date().setDate(new Date().getDate() - 10))} // Set minDate to 5 days before today
								error={
									validation.touched['register_date'] &&
									validation.errors['register_date']
										? validation.errors['register_date']
										: ''
								}
								disabled={cs && pgs}
								clearable={true}
							/>
						</DatesProvider>
					</Col>

					<Col lg={2}>
						<OInput
							name='unit_measurement_name'
							label='Unidad Medida'
							type='text'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={unit_measurement_name}
						/>
					</Col>
					<Col lg={cs ? 2 : 3}>
						<OInput
							name='fuel_type_name'
							label='Tipo de Combustible'
							type='text'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={fuel_type_name}
						/>
					</Col>
					<Col lg={2} hidden={pgs}>
						<OInput
							name='fuel_tank_name'
							label='Estanque de Combustible'
							type='text'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={fuel_tank_name}
						/>
					</Col>
					<Col lg={cs ? 2 : 3}>
						<OInput
							name='stock'
							label='Saldo'
							type='text'
							validation={validation}
							disabled={true}
							classNameLabel='form-label'
							classNameInput='form-control'
							value={stock}
						/>
					</Col>

					<OHr text={'Documentación'} visible={fileCol} />

					<Col lg={3} hidden={fileCol} className='mt-0'>
						<OSelect
							key={
								'file_type_id' + validation.values.fuel_supply_type_id
							}
							label='Tipo Documento'
							id='file_type_id'
							name='file_type_id'
							isRequired={true}
							value={validation.values.file_type_id || ''}
							onSelect={handleTypeDocumentSelect}
							requestApi={() =>
								getFileType({ types: code_type_document })
							}
							validation={validation}
						/>
					</Col>

					<Col lg={7} hidden={fileCol} className='mt-0'>
						<OInput
							name='document'
							label={`${name_type_document}`}
							type='file'
							validation={validation}
							onChange={handleFileChange}
							classNameLabel='form-label'
							classNameInput='form-control'
							isRequired={true}
							value={fileName ? undefined : ''}
						/>
					</Col>

					<Col lg={12}>
						<OInput
							name='observation'
							label='Observación'
							type='textarea'
							validation={validation}
							placeholder='Ingrese una observación'
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating || errorFuelTank}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'>
								<Spinner size='sm' />
							</i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Registrar'} Consumo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default PowerGenerationConsumptionForm;
